/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/time';
import '../common/currency';
import './model';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bizbank": {
        "nested": {
          "transaction_dispute": {
            "nested": {
              "TransactionDispute": {
                "fields": {
                  "id": {
                    "type": "int64",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "status": {
                    "type": "squareup.bizbank.transaction_dispute.DisputeStatus",
                    "id": 3,
                    "rule": "optional"
                  },
                  "statusLastUpdatedDate": {
                    "type": "squareup.common.time.DateTime",
                    "id": 4,
                    "rule": "optional"
                  },
                  "transactionToken": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "marqetaCaseToken": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "disputeAmount": {
                    "type": "squareup.common.Money",
                    "id": 7,
                    "rule": "optional"
                  },
                  "transactionDate": {
                    "type": "squareup.common.time.DateTime",
                    "id": 8,
                    "rule": "optional"
                  },
                  "disputeForm": {
                    "type": "squareup.bizbank.transaction_dispute.DisputeForm",
                    "id": 9,
                    "rule": "optional"
                  },
                  "sellerDisputedDate": {
                    "type": "squareup.common.time.DateTime",
                    "id": 10,
                    "rule": "optional"
                  },
                  "squareDisputedDate": {
                    "type": "squareup.common.time.DateTime",
                    "id": 11,
                    "rule": "optional"
                  },
                  "outreachUrl": {
                    "type": "string",
                    "id": 12,
                    "rule": "optional"
                  },
                  "reasonCode": {
                    "type": "squareup.bizbank.transaction_dispute.ReasonCode",
                    "id": 13,
                    "rule": "optional"
                  },
                  "provisionalCreditAmount": {
                    "type": "squareup.common.Money",
                    "id": 14,
                    "rule": "optional"
                  },
                  "provisionalCreditIssuedDate": {
                    "type": "squareup.common.time.DateTime",
                    "id": 15,
                    "rule": "optional"
                  },
                  "provisionalCreditDebitedDate": {
                    "type": "squareup.common.time.DateTime",
                    "id": 16,
                    "rule": "optional"
                  },
                  "finalResolution": {
                    "type": "squareup.bizbank.transaction_dispute.FinalResolution",
                    "id": 17,
                    "rule": "optional"
                  },
                  "resolutionReason": {
                    "type": "squareup.bizbank.transaction_dispute.ResolutionReason",
                    "id": 18,
                    "rule": "optional"
                  },
                  "finalResolutionDate": {
                    "type": "squareup.common.time.DateTime",
                    "id": 19,
                    "rule": "optional"
                  },
                  "finalFollowUpDate": {
                    "type": "squareup.common.time.DateTime",
                    "id": 20,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 21,
                    "rule": "optional"
                  },
                  "updatedAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 22,
                    "rule": "optional"
                  },
                  "marqetaDisputeFiledByLdap": {
                    "type": "string",
                    "id": 23,
                    "rule": "optional"
                  },
                  "marqetaChargebackToken": {
                    "type": "string",
                    "id": 24,
                    "rule": "optional"
                  },
                  "publicStatus": {
                    "type": "squareup.bizbank.transaction_dispute.PublicStatus",
                    "id": 25,
                    "rule": "optional"
                  }
                }
              },
              "ReasonCode": {
                "values": {
                  "UNKNOWN_REASON_CODE": 0,
                  "FRAUD_OR_UNAUTHORIZED": 1,
                  "NOT_RECEIVED": 2,
                  "NOT_DESCRIBED": 3,
                  "DUPLICATE_PROCESSING": 4,
                  "TRANSACTION_AMOUNT_INCORRECT": 5,
                  "CANCELED_OR_CREDIT_NOT_PROCESSED": 6
                }
              },
              "DisputeStatus": {
                "values": {
                  "UNKNOWN_DISPUTE_STATUS": 0,
                  "NEW": 1,
                  "WAITING_ON_CARD_HOLDER": 2,
                  "FILED": 3,
                  "INITIATED": 4,
                  "REPRESENTMENT": 5,
                  "PREARBITRATION": 6,
                  "ARBITRATION": 7,
                  "NETWORK_REJECTED": 8,
                  "WON": 9,
                  "LOST": 10,
                  "CLOSED": 11,
                  "PENDING_AUTOMATED_REVIEW": 12,
                  "PREARBITRATION_RESPONDED": 13
                }
              },
              "PublicStatus": {
                "values": {
                  "UNKNOWN_PUBLIC_STATUS": 0,
                  "PENDING_REVIEW": 1,
                  "INFORMATION_NEEDED": 2,
                  "IN_PROGRESS": 3,
                  "SELLER_WON": 4,
                  "SELLER_LOST": 5,
                  "RESOLVED": 6
                }
              },
              "FinalResolution": {
                "values": {
                  "UNKNOWN_FINAL_RESOLUTION": 0,
                  "APPROVED": 1,
                  "DENIED": 2,
                  "CREDITED_FROM_SQUARE": 3,
                  "VOIDED": 4,
                  "REJECTED_BY_SQUARE": 5,
                  "REFUNDED": 6,
                  "REJECTED_BY_MARQETA": 7,
                  "DENIED_WARNING": 8
                }
              },
              "ResolutionReason": {
                "values": {
                  "UNKNOWN_RESOLUTION_REASON": 0,
                  "ATO": 1,
                  "BUSINESS_DECISION": 2,
                  "CARDHOLDER_CANCELED_CLAIM": 3,
                  "DISPUTE_LOST": 4,
                  "DISPUTE_WON": 5,
                  "DENIAL_GUIDELINES": 6,
                  "LESS_THAN_25_DOLLARS": 7,
                  "NO_REPLY": 8,
                  "PAYMENT_WITH_CHIP_AND_PIN": 9,
                  "REFUND": 10,
                  "TRANSACTION_VOID": 11,
                  "MULTIPLE_TRANSACTIONS": 12,
                  "RESOLUTION_OVERTURNED": 13,
                  "INACCURATE_OR_INCOMPLETE": 14,
                  "AUTO_CHIP_OR_CONTACTLESS_WITH_CARD_IN_POSSESSION": 19,
                  "AUTO_CARD_PIN_USED": 20,
                  "AUTO_MOBILE_PAYMENT": 21,
                  "AUTO_CONSENT_PROVIDED": 22
                }
              },
              "DisputeForm": {
                "fields": {
                  "merchantName": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "transactionDate": {
                    "type": "squareup.common.time.DateTime",
                    "id": 2,
                    "rule": "optional"
                  },
                  "disputeAmount": {
                    "type": "int64",
                    "id": 3,
                    "rule": "optional"
                  },
                  "usedWithMerchantBefore": {
                    "type": "squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer",
                    "id": 4,
                    "rule": "optional"
                  },
                  "provideCardOrInformation": {
                    "type": "squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer",
                    "id": 5,
                    "rule": "optional"
                  },
                  "cardInPossession": {
                    "type": "squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer",
                    "id": 6,
                    "rule": "optional"
                  },
                  "firstDateCardMissing": {
                    "type": "squareup.common.time.DateTime",
                    "id": 7,
                    "rule": "optional"
                  },
                  "lastTransaction": {
                    "type": "squareup.bizbank.transaction_dispute.DisputeForm.LastTransaction",
                    "id": 8,
                    "rule": "optional"
                  },
                  "sharedPinWithAnyone": {
                    "type": "squareup.bizbank.transaction_dispute.DisputeForm.SharedPinWithAnyone",
                    "id": 9,
                    "rule": "optional"
                  },
                  "receivedExpectedProducts": {
                    "type": "squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer",
                    "id": 10,
                    "rule": "optional"
                  },
                  "didNotReceiveProductsDetails": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "receivedProductsOnAgreedDate": {
                    "type": "squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer",
                    "id": 12,
                    "rule": "optional"
                  },
                  "receivedExpectedProductsDate": {
                    "type": "squareup.common.time.DateTime",
                    "id": 13,
                    "rule": "optional"
                  },
                  "productsReceivedWereAsDescribed": {
                    "type": "squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer",
                    "id": 14,
                    "rule": "optional"
                  },
                  "productsReceivedWereNotAsDescribedDetails": {
                    "type": "string",
                    "id": 15,
                    "rule": "optional"
                  },
                  "chargedMultipleTimes": {
                    "type": "squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer",
                    "id": 16,
                    "rule": "optional"
                  },
                  "chargedMultipleTimesCorrectTransaction": {
                    "type": "squareup.bizbank.transaction_dispute.DisputeForm.ChargedMultipleTimes",
                    "id": 17,
                    "rule": "optional"
                  },
                  "amountIsCorrect": {
                    "type": "squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer",
                    "id": 18,
                    "rule": "optional"
                  },
                  "correctChargeAmount": {
                    "type": "int64",
                    "id": 27,
                    "rule": "optional"
                  },
                  "purchaseWasCanceled": {
                    "type": "squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer",
                    "id": 19,
                    "rule": "optional"
                  },
                  "purchasedCanceledDate": {
                    "type": "squareup.common.time.DateTime",
                    "id": 20,
                    "rule": "optional"
                  },
                  "merchandiseIsReturned": {
                    "type": "squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer",
                    "id": 21,
                    "rule": "optional"
                  },
                  "returnedMerchandise": {
                    "type": "squareup.bizbank.transaction_dispute.DisputeForm.ReturnedMerchandise",
                    "id": 22,
                    "rule": "optional"
                  },
                  "merchantAgreedToIssueCredit": {
                    "type": "squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer",
                    "id": 23,
                    "rule": "optional"
                  },
                  "merchantAgreedToIssueCreditDate": {
                    "type": "squareup.common.time.DateTime",
                    "id": 24,
                    "rule": "optional"
                  },
                  "anythingElse": {
                    "type": "string",
                    "id": 25,
                    "rule": "optional"
                  },
                  "pinWasWrittenDown": {
                    "type": "squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer",
                    "id": 26,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "DisputeFormAnswer": {
                    "values": {
                      "UNKNOWN_ANSWER": 0,
                      "NO": 1,
                      "YES": 2
                    }
                  },
                  "LastTransaction": {
                    "fields": {
                      "lastTransactionDate": {
                        "type": "squareup.common.time.DateTime",
                        "id": 1,
                        "rule": "optional"
                      },
                      "lastTransactionMerchant": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "SharedPinWithAnyone": {
                    "fields": {
                      "hasSharedPinWithAnyone": {
                        "type": "squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer",
                        "id": 1,
                        "rule": "optional"
                      },
                      "sharedPinPerson": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "ChargedMultipleTimes": {
                    "fields": {
                      "correctChargeDate": {
                        "type": "squareup.common.time.DateTime",
                        "id": 1,
                        "rule": "optional"
                      },
                      "correctChargeAmount": {
                        "type": "int64",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "ReturnedMerchandise": {
                    "fields": {
                      "returnedMerchandiseDate": {
                        "type": "squareup.common.time.DateTime",
                        "id": 1,
                        "rule": "optional"
                      },
                      "returnedMerchandiseProof": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "GetTransactionDisputeActivityRequest": {
                "fields": {
                  "transactionDisputeId": {
                    "type": "int64",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetTransactionDisputeActivityResponse": {
                "fields": {
                  "events": {
                    "type": "squareup.bizbank.transaction_dispute.Event",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "Event": {
                "fields": {
                  "eventAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 1,
                    "rule": "optional"
                  },
                  "statusChangeEvent": {
                    "type": "squareup.bizbank.transaction_dispute.Event.StatusChangeEvent",
                    "id": 2
                  },
                  "futureStatusChangeEvent": {
                    "type": "squareup.bizbank.transaction_dispute.Event.FutureStatusChangeEvent",
                    "id": 3
                  },
                  "creditIssuedEvent": {
                    "type": "squareup.bizbank.transaction_dispute.Event.CreditIssuedEvent",
                    "id": 4
                  },
                  "creditDebitedEvent": {
                    "type": "squareup.bizbank.transaction_dispute.Event.CreditDebitedEvent",
                    "id": 5
                  }
                },
                "nested": {
                  "StatusChangeEvent": {
                    "fields": {
                      "publicStatus": {
                        "type": "squareup.bizbank.transaction_dispute.PublicStatus",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "FutureStatusChangeEvent": {
                    "fields": {
                      "publicStatus": {
                        "type": "squareup.bizbank.transaction_dispute.PublicStatus",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "CreditIssuedEvent": {
                    "fields": {
                      "amount": {
                        "type": "squareup.common.Money",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "CreditDebitedEvent": {
                    "fields": {
                      "amount": {
                        "type": "squareup.common.Money",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "event": {
                    "oneof": ["statusChangeEvent", "futureStatusChangeEvent", "creditIssuedEvent", "creditDebitedEvent"]
                  }
                }
              },
              "ListTransactionDisputesRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "beginTime": {
                    "type": "squareup.common.time.DateTime",
                    "id": 2,
                    "rule": "optional"
                  },
                  "endTime": {
                    "type": "squareup.common.time.DateTime",
                    "id": 3,
                    "rule": "optional"
                  },
                  "includeStatuses": {
                    "type": "squareup.bizbank.transaction_dispute.DisputeStatus",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "inProgressOnly": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  },
                  "batchRequest": {
                    "type": "squareup.bizbank.model.BatchRequest",
                    "id": 6,
                    "rule": "optional"
                  },
                  "resolvedOnly": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional"
                  },
                  "transactionToken": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  }
                }
              },
              "ListTransactionDisputesResponse": {
                "fields": {
                  "transactionDisputes": {
                    "type": "squareup.bizbank.transaction_dispute.TransactionDispute",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "paginationToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.TransactionDispute && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.ReasonCode && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.DisputeStatus && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.PublicStatus && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.FinalResolution && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.ResolutionReason && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.DisputeForm && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.DisputeForm?.nested?.DisputeFormAnswer && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.DisputeForm?.nested?.LastTransaction && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.DisputeForm?.nested?.SharedPinWithAnyone && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.DisputeForm?.nested?.ChargedMultipleTimes && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.DisputeForm?.nested?.ReturnedMerchandise && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.GetTransactionDisputeActivityRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.GetTransactionDisputeActivityResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.Event && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.Event?.nested?.StatusChangeEvent && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.Event?.nested?.FutureStatusChangeEvent && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.Event?.nested?.CreditIssuedEvent && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.Event?.nested?.CreditDebitedEvent && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.ListTransactionDisputesRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.ListTransactionDisputesResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE TransactionDispute @ squareup/bizbank/transaction_dispute.proto at 15:1
 */
export const TransactionDispute = $root.lookupType('squareup.bizbank.transaction_dispute.TransactionDispute');
fixType(TransactionDispute);
Builder.createAndAttachToType(TransactionDispute);
/**
 * SOURCE ReasonCode @ squareup/bizbank/transaction_dispute.proto at 98:1
 */
export const ReasonCode = $root.lookupEnum('squareup.bizbank.transaction_dispute.ReasonCode').values;
/**
 * SOURCE DisputeStatus @ squareup/bizbank/transaction_dispute.proto at 108:1
 */
export const DisputeStatus = $root.lookupEnum('squareup.bizbank.transaction_dispute.DisputeStatus').values;
/**
 * SOURCE PublicStatus @ squareup/bizbank/transaction_dispute.proto at 125:1
 */
export const PublicStatus = $root.lookupEnum('squareup.bizbank.transaction_dispute.PublicStatus').values;
/**
 * SOURCE FinalResolution @ squareup/bizbank/transaction_dispute.proto at 135:1
 */
export const FinalResolution = $root.lookupEnum('squareup.bizbank.transaction_dispute.FinalResolution').values;
/**
 * SOURCE ResolutionReason @ squareup/bizbank/transaction_dispute.proto at 149:1
 */
export const ResolutionReason = $root.lookupEnum('squareup.bizbank.transaction_dispute.ResolutionReason').values;
/**
 * SOURCE DisputeForm @ squareup/bizbank/transaction_dispute.proto at 176:1
 */
export const DisputeForm = $root.lookupType('squareup.bizbank.transaction_dispute.DisputeForm');
fixType(DisputeForm);
Builder.createAndAttachToType(DisputeForm);
/**
 * SOURCE DisputeFormAnswer @ squareup/bizbank/transaction_dispute.proto at 177:3
 */
DisputeForm.DisputeFormAnswer = $root.lookupEnum('squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer').values;
/**
 * What was the last transaction you made with your Square Card?
 *
 * SOURCE LastTransaction @ squareup/bizbank/transaction_dispute.proto at 205:3
 */
DisputeForm.LastTransaction = $root.lookupType('squareup.bizbank.transaction_dispute.DisputeForm.LastTransaction');
fixType(DisputeForm.LastTransaction);
Builder.createAndAttachToType(DisputeForm.LastTransaction);
/**
 * SOURCE SharedPinWithAnyone @ squareup/bizbank/transaction_dispute.proto at 212:3
 */
DisputeForm.SharedPinWithAnyone = $root.lookupType('squareup.bizbank.transaction_dispute.DisputeForm.SharedPinWithAnyone');
fixType(DisputeForm.SharedPinWithAnyone);
Builder.createAndAttachToType(DisputeForm.SharedPinWithAnyone);
/**
 * If you were charged multiple times for this payment, what was the date and amount of the correct transaction?
 *
 * SOURCE ChargedMultipleTimes @ squareup/bizbank/transaction_dispute.proto at 243:3
 */
DisputeForm.ChargedMultipleTimes = $root.lookupType('squareup.bizbank.transaction_dispute.DisputeForm.ChargedMultipleTimes');
fixType(DisputeForm.ChargedMultipleTimes);
Builder.createAndAttachToType(DisputeForm.ChargedMultipleTimes);
/**
 * If you’ve returned the merchandise, please provide the return date and provide proof of return authorization (i.e tracking number, delivery confirmation, or return merchandise authorization)
 *
 * SOURCE ReturnedMerchandise @ squareup/bizbank/transaction_dispute.proto at 265:3
 */
DisputeForm.ReturnedMerchandise = $root.lookupType('squareup.bizbank.transaction_dispute.DisputeForm.ReturnedMerchandise');
fixType(DisputeForm.ReturnedMerchandise);
Builder.createAndAttachToType(DisputeForm.ReturnedMerchandise);
/**
 * SOURCE GetTransactionDisputeActivityRequest @ squareup/bizbank/transaction_dispute.proto at 293:1
 */
export const GetTransactionDisputeActivityRequest = $root.lookupType('squareup.bizbank.transaction_dispute.GetTransactionDisputeActivityRequest');
fixType(GetTransactionDisputeActivityRequest, {
  transactionDisputeId: {
    required: true
  }
});
Builder.createAndAttachToType(GetTransactionDisputeActivityRequest);
/**
 * SOURCE GetTransactionDisputeActivityResponse @ squareup/bizbank/transaction_dispute.proto at 297:1
 */
export const GetTransactionDisputeActivityResponse = $root.lookupType('squareup.bizbank.transaction_dispute.GetTransactionDisputeActivityResponse');
fixType(GetTransactionDisputeActivityResponse);
Builder.createAndAttachToType(GetTransactionDisputeActivityResponse);
/**
 * SOURCE Event @ squareup/bizbank/transaction_dispute.proto at 301:1
 */
export const Event = $root.lookupType('squareup.bizbank.transaction_dispute.Event');
fixType(Event);
Builder.createAndAttachToType(Event);
/**
 * SOURCE StatusChangeEvent @ squareup/bizbank/transaction_dispute.proto at 311:3
 */
Event.StatusChangeEvent = $root.lookupType('squareup.bizbank.transaction_dispute.Event.StatusChangeEvent');
fixType(Event.StatusChangeEvent);
Builder.createAndAttachToType(Event.StatusChangeEvent);
/**
 * SOURCE FutureStatusChangeEvent @ squareup/bizbank/transaction_dispute.proto at 315:3
 */
Event.FutureStatusChangeEvent = $root.lookupType('squareup.bizbank.transaction_dispute.Event.FutureStatusChangeEvent');
fixType(Event.FutureStatusChangeEvent);
Builder.createAndAttachToType(Event.FutureStatusChangeEvent);
/**
 * SOURCE CreditIssuedEvent @ squareup/bizbank/transaction_dispute.proto at 319:3
 */
Event.CreditIssuedEvent = $root.lookupType('squareup.bizbank.transaction_dispute.Event.CreditIssuedEvent');
fixType(Event.CreditIssuedEvent);
Builder.createAndAttachToType(Event.CreditIssuedEvent);
/**
 * SOURCE CreditDebitedEvent @ squareup/bizbank/transaction_dispute.proto at 323:3
 */
Event.CreditDebitedEvent = $root.lookupType('squareup.bizbank.transaction_dispute.Event.CreditDebitedEvent');
fixType(Event.CreditDebitedEvent);
Builder.createAndAttachToType(Event.CreditDebitedEvent);
/**
 * SOURCE ListTransactionDisputesRequest @ squareup/bizbank/transaction_dispute.proto at 328:1
 */
export const ListTransactionDisputesRequest = $root.lookupType('squareup.bizbank.transaction_dispute.ListTransactionDisputesRequest');
fixType(ListTransactionDisputesRequest, {
  unitToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ListTransactionDisputesRequest);
/**
 * SOURCE ListTransactionDisputesResponse @ squareup/bizbank/transaction_dispute.proto at 339:1
 */
export const ListTransactionDisputesResponse = $root.lookupType('squareup.bizbank.transaction_dispute.ListTransactionDisputesResponse');
fixType(ListTransactionDisputesResponse);
Builder.createAndAttachToType(ListTransactionDisputesResponse);